
/* eslint-disable */
import{get,post}from"./request";
const getMessagesList=param=>get("/question/list",param),
      remove=param=>post("/question/"+param+"/delete"),
      createMessage=param=>post("/question/create",param),
      sendPhoneCode=param=>post("/question/code",param),
      removeSelected=param=>post("/question/batch/delete",param),
      saveReply=param=>post("/reply/create",param),getItemInfo=param=>get("/question/selectById",param),
      publishSelected=param=>get("/question/publish",param),unpublishSelected=param=>get("/question/unpublish",param),
      adminLogin=param=>get("/message/adminlogin",param),
      adminList = param => get(`/sysUser/list`,param),
      adminAdd = param => post("/sysUser/add",param),
      adminDel = param => post("/sysUser/"+param+"/delete"),
      adminSet = param => post("/sysUser/update",param);
export default{
      getMessagesList:getMessagesList,
      remove:remove,
      createMessage:createMessage,
      sendPhoneCode:sendPhoneCode,
      removeSelected:removeSelected,
      saveReply:saveReply,
      getItemInfo:getItemInfo,
      publishSelected:publishSelected,
      unpublishSelected:unpublishSelected,
      adminLogin:adminLogin,
      adminList,
      adminAdd,
      adminDel,
      adminSet
};



// WEBPACK FOOTER //
// ./src/api/index.js